import { RotaCustomizada } from "shared/components";
import LayoutNaoAutenticado from "shared/layout/LayoutNaoAutenticado";
import CadastreSe from "explorer/pages/cadastre-se/CadastreSe";
import Login from "explorer/pages/login/Login";
import NotFound from "shared/pages/not-found/NotFound";
import ArtistsRanking from "radar/pages/rankings/artists-ranking/ArtistsRanking";
import ResetSenha from "explorer/pages/reset-senha/ResetSenha";
import VerificacaoLogin from "explorer/pages/verificacao-login/VerificacaoLogin";
import { Switch } from "react-router-dom";
import LayoutRadar from "radar/layout/LayoutRadar";
import Comparison from "radar/pages/comparison/Comparison";
import ArtistProfile from "radar/pages/artist-profile/ArtistProfile";
import TopSpotify from "radar/pages/top-spotify/TopSpotify";
import ArtistNetwork from "radar/pages/rankings/artist-network/ArtistNetwork";
import RadarExplore from "radar/pages/radar/Radar";
import VerificacaoDispositivo from "explorer/pages/verificacao-dispositivo/VerificacaoDispositivo";
import GenresAudioFeaturesTrend from "radar/pages/genres-audio-feature-trend/GenresAudioFeaturesTrend";
import LabelsRanking from "radar/pages/rankings/labels-ranking/LabelsRanking";
import LayoutSemMargem from "shared/layout/LayoutSemMargem";
import ReleasesRanking from "radar/pages/rankings/releases-ranking/ReleasesRanking";
import TracksRanking from "radar/pages/rankings/tracks-ranking/TracksRanking";
import Tutorial from "radar/pages/tutorial/Tutorial";
import TeamRequest from "radar/pages/team-request/TeamRequest";
import ConviteRadarSucesso from "radar/pages/convite-radar/ConviteRadarSucesso";
import TeamStart from "radar/pages/team-start/TeamStart";
import { UserStatus } from "shared/enums/UserStatus";
import TeamDisabled from "radar/pages/team-disabled/TeamDisabled";
import TeamConfiguration from "radar/pages/team-management/TeamConfiguration";
import Home from "radar/pages/home/Home";
import Diagnotic from "radar/pages/diagnostic/Diagnostic";
import CheckoutDiagnostico from "radar/pages/checkout-diagnostico/CheckoutDiagnostico";
import Checkout from "radar/pages/checkout/Checkout";
import LabelProfile from "radar/pages/label-profile/LabelProfile";
import CareerDiagnose from "diagnose/pages/career-diagnose/CareerDiagnose";
import DiagnoseLayout from "diagnose/components/diagnose-layout/DiagnoseLayout";
import MeusDados from "radar/pages/meus-dados/MeusDados";
import ConfirmationCheckout from "radar/pages/confirmation-checkout/ConfirmationCheckout";
import RolesRanking from "radar/pages/rankings/roles-ranking/RolesRanking";
import LabelManagement from "shared/pages/label-management/LabelManagement";

const radarPermissions = [
  UserStatus.AdminStrm,
  UserStatus.AdminTeam,
  UserStatus.ViewerTeam,
  UserStatus.ManagerTeam,
];

const Routes = () => {
  return (
    <Switch>
      {/* EXPLORER */}
      <RotaCustomizada
        path="/:lang?/login"
        exact
        component={Login}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
      <RotaCustomizada
        path="/reset-senha"
        exact
        component={ResetSenha}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
      <RotaCustomizada
        path="/cadastre"
        exact
        component={CadastreSe}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
      <RotaCustomizada
        path="/verificacao"
        exact
        component={VerificacaoLogin}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
      <RotaCustomizada
        path="/verificacao-dispositivo"
        exact
        component={VerificacaoDispositivo}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
      {/* No Radar CLaim */}
      <RotaCustomizada
        path="/radar"
        exact
        component={RadarExplore}
        layout={LayoutSemMargem}
      />
      <RotaCustomizada
        path="/meus-dados-radar"
        exact
        component={MeusDados}
        layout={LayoutSemMargem}
      />
      <RotaCustomizada
        path="/"
        exact
        component={Home}
        layout={LayoutRadar}
        statusNecessario={[...radarPermissions]}
      />
      {/* RADAR */}
      <RotaCustomizada
        path="/artist-ranking"
        exact
        component={ArtistsRanking}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/labels-ranking"
        exact
        component={LabelsRanking}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/releases-ranking"
        exact
        component={ReleasesRanking}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/tracks-ranking"
        exact
        component={TracksRanking}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/role-ranking"
        exact
        component={RolesRanking}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/comparison"
        exact
        component={Comparison}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/artist-profile/:id"
        exact
        component={ArtistProfile}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/artist-profile"
        exact
        component={ArtistProfile}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/label-profile"
        exact
        component={LabelProfile}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/trends"
        exact
        component={TopSpotify}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/artist-network"
        exact
        component={ArtistNetwork}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/genres-audio-features-trend"
        exact
        component={GenresAudioFeaturesTrend}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/label-management"
        exact
        component={LabelManagement}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />

      <RotaCustomizada
        path="/tutorial"
        exact
        component={Tutorial}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/team-request"
        exact
        component={TeamRequest}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions, UserStatus.New]}
      />
      <RotaCustomizada
        path="/team-request-awaiting"
        exact
        component={ConviteRadarSucesso}
        layout={LayoutRadar}
        statusNecessario={[...radarPermissions, UserStatus.PendingCommercial]}
      />
      <RotaCustomizada
        path="/team-issue"
        exact
        component={TeamDisabled}
        layout={LayoutRadar}
        statusNecessario={[UserStatus.TeamDisabled]}
      />
      <RotaCustomizada
        path="/team-configuration"
        exact
        component={TeamConfiguration}
        layout={LayoutRadar}
        claimNecessaria="radar"
        // statusNecessario={[UserStatus.AdminTeam]}
      />
      <RotaCustomizada
        path="/checkout-diagnostico"
        exact
        component={CheckoutDiagnostico}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/checkout"
        exact
        component={Checkout}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[...radarPermissions]}
      />
      <RotaCustomizada
        path="/confirmacao"
        exact
        component={ConfirmationCheckout}
        layout={LayoutRadar}
      />
      <RotaCustomizada
        path="/team-start"
        exact
        component={TeamStart}
        layout={LayoutRadar}
        claimNecessaria="radar"
        statusNecessario={[UserStatus.CommercialDone]}
      />
      {/* Diagnostico */}
      <RotaCustomizada
        path="/diagnostico-carreira/:id"
        exact
        component={CareerDiagnose}
        layout={DiagnoseLayout}
      />
      {/* COMPARTILHADA */}
      <RotaCustomizada
        path="/meus-dados"
        exact
        component={MeusDados}
        layout={LayoutRadar}
      />
      <RotaCustomizada
        path="/diagnostic"
        exact
        component={Diagnotic}
        layout={LayoutRadar}
      />
      <RotaCustomizada
        component={NotFound}
        autenticacaoNecessaria={false}
        layout={LayoutNaoAutenticado}
      />
    </Switch>
  );
};

export default Routes;
